import {
  AddConsultantEventLogCommentMutationVariables,
  useAddConsultantEventLogCommentMutation
} from "@bonliva-crm/graphql";
import { HookProps } from "../utils/hook-props";

export function useAddConsultantEventLogComment(props: HookProps) {
  const [addConsultantEventLogCommentMutation] = useAddConsultantEventLogCommentMutation({
    onError: (error) => {
      console.error(error);
      props.onError && props.onError(error);
    },
    onCompleted: (res) => {
      props.onCompleted && props.onCompleted(res.addConsultantCommentEvent);
    }
  });

  const addConsultantEventLogComment = (
    args: AddConsultantEventLogCommentMutationVariables
  ) => {
    props.onBeforeCall && props.onBeforeCall();
    addConsultantEventLogCommentMutation({
      variables: args
    });
  };

  return { addConsultantEventLogComment };
}
